'use client';

import React, { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { initializeDatadog, setDatadogUser } from './client-config';

interface DatadogProviderProps {
	children: React.ReactNode;
}

export function DatadogProvider({ children }: DatadogProviderProps) {
	const { data: session, status } = useSession();

	useEffect(() => {
		// Initialize Datadog when the component mounts
		initializeDatadog().catch((error) => {
			console.error('[DatadogProvider] Failed to initialize Datadog:', error);
		});
	}, []);

	useEffect(() => {
		// Set user information when session is available
		if (status === 'authenticated' && session?.user) {
			setDatadogUser({
				id: session.user.id,
				email: session.user.email,
				name: `${session.user.firstName} ${session.user.lastName}`,
				tenantId: session.user.organizationName,
			}).catch((error) => {
				console.error('[DatadogProvider] Failed to set user:', error);
			});
		}
	}, [session, status]);

	return children;
}
